<template>
	<v-container style="text-align:left;  background-color: white !important;">
		<v-row align="center">
			<v-col cols="3">
				<v-img src="@/assets/ciclo-urbano.png" width="200px"></v-img>
			</v-col>
			<v-col cols="9" class="text-left overline">
				<div>
					UrbanPlagas SpA
				</div>
				<div>
					Diseño, mantención de areas verdes y manejo integral en control de plagas
				</div>
				<div>
					r.u.t 76.693.777-2
				</div>
				<div>Clorinda Henriquez 99, La reina, R.M.</div>
				<div>2 3217 22 11 / +56978901179</div>
				<a href="https://www.ciclourbano.cl" target="_blank" style="text-decoration: none">
					www.ciclourbano.cl
				</a>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="4">
				<div class="text-left">
					<span class="body-2"> Solicitado por: </span>
					<b :class="{ 'primary--text': hasInfo(order[9]) }">{{ order[9] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Correo: </span>
					<b :class="{ 'primary--text': hasInfo(order[order.length - 2]) }">{{
						order[order.length - 2]
					}}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Rut: </span>
					<b :class="{ 'primary--text': hasInfo(order[2]) }">{{ order[2] }}</b>
				</div>
				<div class="text-left" :class="{ 'primary--text': hasInfo(order[3]) }">
					<span class="body-2"> Dirección: </span
					><b :class="{ 'primary--text': hasInfo(order[3]) }">{{ order[3] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Comuna / Ciudad: </span
					><b :class="{ 'primary--text': hasInfo(order[4]) }">{{ order[4] }}</b>
				</div>
			</v-col>
			<!-- Eliminado por peticion del cliente-->
			<!-- <v-col cols="12" sm="4">
				<div class="text-left">
					<span class="body-2"> Autorizado por: </span>
					<b :class="{ 'primary--text': hasInfo(order[5]) }">{{ order[5] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Rut: </span>
					<b :class="{ 'primary--text': hasInfo(order[6]) }">{{ order[6] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Dirección: </span
					><b :class="{ 'primary--text': hasInfo(order[7]) }">{{ order[7] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> Comuna / Ciudad: </span
					><b :class="{ 'primary--text': hasInfo(order[8]) }">{{ order[8] }}</b>
				</div>
			</v-col> -->
			<v-col cols="12" sm="4">
				<div class="text-left">
					<span class="body-2"> Fecha: </span>
					<b :class="{ 'primary--text': hasInfo(order[1]) }">{{ order[1] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2"> N° orden de trabajo: </span>
					<b :class="{ 'primary--text': hasInfo(order[0]) }">{{ order[0] }}</b>
				</div>
				<div class="text-left">
					<span class="body-2">Dirección perimetral:</span>
					<b :class="{ 'primary--text': hasInfo(order[0]) }" v-if="place.address">{{
						place.address
					}}</b>
					<b :class="{ 'primary--text': hasInfo(order[0]) }" v-else>
						No hay perimetro establecido
					</b>
				</div>

				<div class="text-left" v-for="(email, index) in place.email" :key="index">
					<span class="body-2">Correo:</span>
					<b :class="{ 'primary--text': hasInfo(order[0]) }">{{ email }}</b>
				</div>
			</v-col>
			<v-col cols="6" class="white--text title font-weight-bold">
				<div class="mr-2 text-center" style="background-color: darkslategrey">
					Servicio Basico
				</div>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="6" class="white--text title font-weight-bold">
				<div class="ml-2 text-center" style="background-color: darkslategrey">
					Adicionales
				</div>
			</v-col>
			<v-col cols="6">
				<v-row class="mr-2">
					<v-col cols="12" class="py-0 title font-weight-bold">Muestreo</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">PH:</span>
						<b :class="{ 'primary--text': hasInfo(order[11]) }">{{ order[11] }}</b>
					</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Cloro:</span>
						<b :class="{ 'primary--text': hasInfo(order[12]) }">{{ order[12] }}</b>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6">
				<v-row align="center" class="ml-2">
					<v-col cols="12" class="py-0 title font-weight-bold">Lavado</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Autolavado filtro:</span>
						<b :class="{ 'primary--text': hasInfo(order[13]) }">{{ order[13] }}</b>
					</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Autolavado filtro:</span>
						<b :class="{ 'primary--text': hasInfo(order[5]) }">{{ order[5] }}</b>
					</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Autolavado filtro:</span>
						<b :class="{ 'primary--text': hasInfo(order[6]) }">{{ order[6] }}</b>
					</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Autolavado filtro:</span>
						<b :class="{ 'primary--text': hasInfo(order[7]) }">{{ order[7] }}</b>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6">
				<v-divider class="pr-2"></v-divider>
			</v-col>
			<v-col cols="6" class="pl-2">
				<v-divider></v-divider>
			</v-col>
			<v-col cols="6">
				<v-row class="mr-2">
					<v-col cols="12" class="py-0 title font-weight-bold">Aspecto del agua</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Transparente: </span>
						<b :class="{ 'primary--text': hasInfo(order[14]) }">{{ order[14] }}</b>
					</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Turbia: </span>
						<b :class="{ 'primary--text': hasInfo(order[15]) }">{{ order[15] }}</b>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6">
				<v-row class="ml-2">
					<v-col cols="12" class="py-0 title font-weight-bold">
						Sistema de bomba y filtro de piscina
					</v-col>
					<v-col cols="12">
						<b :class="{ 'primary--text': hasInfo(order[16]) }">{{ order[16] }}</b>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6">
				<v-divider class="pr-2"></v-divider>
			</v-col>
			<v-col cols="6" class="pl-2">
				<v-divider></v-divider>
			</v-col>
			<v-col cols="6">
				<v-row class="mr-2">
					<v-col cols="12" class="py-0 title font-weight-bold">Servicio</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Aspirado: </span>
						<b :class="{ 'primary--text': hasInfo(order[17]) }">{{ order[17] }}</b>
					</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Cepillado: </span>
						<b :class="{ 'primary--text': hasInfo(order[18]) }">{{ order[18] }}</b>
					</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Retiro de basura: </span>
						<b :class="{ 'primary--text': hasInfo(order[19]) }">{{ order[19] }}</b>
					</v-col>
					<v-col cols="6">
						<span class="body-1 font-weight-bold mr-4">Limpieza en piscina: </span>
						<b :class="{ 'primary--text': hasInfo(order[20]) }">{{ order[20] }}</b>
					</v-col>
					<v-col cols="5">
						<span class="body-1 font-weight-bold mr-1">Adicion de cloro: </span>
						<b :class="{ 'primary--text': hasInfo(order[21]) }">{{ order[21] }}</b>
					</v-col>
					<v-col cols="7" class="text-right">
						<span class="body-1 font-weight-bold mr-1">Adicion de alguicida: </span>
						<b :class="{ 'primary--text': hasInfo(order[22]) }">{{ order[22] }}</b>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6">
				<v-row class="ml-2">
					<v-col cols="12" class="py-0 title font-weight-bold"> </v-col>
					<v-col cols="6" class="py-0">
						<div class="subtitle-1 font-weight-bold">Estado cuarzo:</div>
						<b :class="{ 'primary--text': hasInfo(order[23]) }">{{ order[23] }}</b>
					</v-col>
					<v-col cols="6" class="py-0">
						<div class="subtitle-1 font-weight-bold">Sistema de bombeo:</div>
						<b :class="{ 'primary--text': hasInfo(order[25]) }">{{ order[25] }}</b>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6">
				<v-divider class="pr-2"></v-divider>
			</v-col>
			<v-col cols="6" class="pl-2">
				<v-divider></v-divider>
			</v-col>
			<v-col cols="6">
				<v-row class="mr-2">
					<v-col cols="6" class="py-0">
						<div class="title font-weight-bold">Cloro:</div>
						<b :class="{ 'primary--text': hasInfo(order[24]) }">{{ order[24] }}</b>
					</v-col>
					<v-col cols="6" class="py-0">
						<div class="title font-weight-bold">PH:</div>
						<b :class="{ 'primary--text': hasInfo(order[26]) }">{{ order[26] }}</b>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="6" class="pt-0">
				<div class="ml-5">
					<span class="title font-weight-bold"> Observaciones/comentarios</span> <br />
					<b :class="{ 'primary--text': hasInfo(order[27]) }">{{ order[27] }}</b>
				</div>
			</v-col>
			<template v-if="images">
				<v-col cols="12">
					Antecedentes fotográficos:
				</v-col>
				<div v-for="(img, key) in images" :key="key" class="d-flex child-flex ">
					<v-img
						v-if="isToday(order[1], img.createAt)"
						lazy-src="@/assets/placeholder.png"
						:src="img.url"
						max-height="200px"
						max-width="200px"
						class="mr-1 mb-1"
						style="border-radius: 15px;"
						alt="imagen de la orden"
					>
						<div class="bg caption text-right" v-if="img.createdAt">
							{{ createAt(img.createdAt) }}
						</div>
					</v-img>
					<div
						class="mr-1 mb-1 pl-2 pt-2"
						style="border-radius: 15px; height: 100px; width: 200px; border: 1px solid black;"
						v-else
					>
						Existe una foto tomada: {{ createAt(img.createdAt) }}
					</div>
				</div>
			</template>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
	props: {
		workOrder: {
			type: Array,
			required: false,
		},
	},
	data() {
		return {
			idLodging: undefined,
			indexWorkOrder: undefined,
			order: [],
			place: '',
			images: [],
		};
	},
	computed: {
		dateTime() {
			return moment(this.order[79]).format('lll');
		},
		...mapGetters({
			lodgingSelect: 'Lodging/lodgingSelect',
		}),
	},
	watch: {
		workOrder() {
			this.order = this.workOrder;
		},
	},
	created() {
		if (!this.$vuetify.breakpoint.lgAndUp)
			document.getElementById('viewport').setAttribute('content', 'width=900');
	},
	mounted() {
		this.idLodging = this.$route.params.idLodging;
		this.indexWorkOrder = this.$route.params.index;
		if (this.workOrder) {
			this.order = this.formatWorkOrder(this.workOrder);
			this.place = this.lodgingSelect.place;
			if (this.lodgingSelect.documents) {
				const documents = this.lodgingSelect.documents;
				this.images = documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			}
		} else if (this.idLodging && this.indexWorkOrder)
			this.getWorkOrder({
				idLodging: this.idLodging,
				indexWorkOrder: this.indexWorkOrder,
			}).then(data => {
				this.order = this.formatWorkOrder(data.workOrder);
				this.place = data.place;
				this.images = data.documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			});
	},
	methods: {
		isToday(orderDate, datePhoto) {
			return moment(orderDate).isSame(datePhoto, 'day');
		},
		createAt(date) {
			if (date) return moment(date).format('lll');
			else return 'Sin fecha';
		},
		hasInfo(item) {
			return item !== 'Sin info';
		},
		validateImage(typeDocument) {
			typeDocument = typeDocument.toLowerCase();
			if (typeDocument === 'jpg' || typeDocument === 'png' || typeDocument === 'peg')
				return true;
			return false;
		},
		formatWorkOrder(workOrder) {
			return workOrder.map(item => {
				if (item === null || item === false) return 'Sin info';
				if (item === true) return 'Si';
				else return item;
			});
		},
		...mapActions({
			getWorkOrder: 'Lodging/getWorkOrder',
		}),
	},
};
</script>

<style scoped>
.bg {
	background-color: rgba(255, 255, 255, 0.5);
}
</style>
